function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import DevelopersTemplate from "components/templates/developers-template/developers-template";
import TryItYourselfEditorComponent from "components/pages/developers/try-it-yourself/try-it-yourself-editor/try-it-yourself-editor-component";
import englishTranslations from "/services/localization/keys/all.json";
class Graphiql extends PureComponent {
    static getInitialProps({ req, res }) {
        return _async_to_generator(function*() {
            const translations = englishTranslations;
            return {
                translations
            };
        })();
    }
    render() {
        const { translations } = this.props;
        return /*#__PURE__*/ _jsx(DevelopersTemplate, {
            translations: translations,
            children: /*#__PURE__*/ _jsx("div", {
                className: "try-it-yourself-page",
                children: /*#__PURE__*/ _jsx(TryItYourselfEditorComponent, {})
            })
        });
    }
}
export { Graphiql as default };
